(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("apiToolkit", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/apiToolkit/apiToolkitView.html",
            controller: ["tenantApiToolkitResource", "messageService", ApiToolkitCtrl],
            controllerAs: "vm"
        };
        function ApiToolkitCtrl(tenantApiToolkitResource, messageService) {
            var vm = this;
            vm.url = location.origin; //could use $location but that requires building the url https://stackoverflow.com/questions/28357205/how-can-i-get-the-base-host-in-angular-js
            vm.model = {};
            vm.saving = false;
            vm.loading = true;
            vm.form = {};
            tenantApiToolkitResource.get(function (data) {
                vm.model = data;
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
            vm.generateSecret = function () {
                if (vm.generating)
                    return;
                vm.generating = true;
                tenantApiToolkitResource.generateSecret(function (data) {
                    vm.model.secret = data.value;
                    vm.generating = false;
                }, function (error) {
                    vm.generating = false;
                    messageService.error(error);
                });
            };
            vm.save = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    tenantApiToolkitResource.save(vm.model, function () {
                        vm.saving = false;
                        messageService.success("common.changesSaved");
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
                else
                    vm.showErrors = true;
            };
        }
    });
})();
